if (!customElements.get('cl-product-carousel')) {
  customElements.define('cl-product-carousel', class extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.controller = new AbortController();
      this.options = JSON.parse(this.querySelector('[data-carousel-options]').textContent);
      if (this.dataset.bestSelling === 'true' && this.dataset.nativeSorted !== 'true' && this.dataset.sourceUrl) {
        try {
          this.setAttribute('aria-busy', 'true');
          const url = new URL(this.dataset.sourceUrl, location.origin);
          url.searchParams.set('sort_by', 'best-selling');
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Collection unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const sorted = document.querySelector('cl-product-carousel[data-native-sorted="true"] [data-carousel-slides]');
          if (!sorted) throw new Error('Sorted collection unavailable');
          this.querySelector('[data-carousel-slides]').replaceChildren(...sorted.childNodes);
          this.dataset.nativeSorted = 'true';
        } catch (error) {
          if (error.name === 'AbortError') return;
          const status = this.querySelector('[role="status"]');
          status.textContent = 'Exibindo os cursos na ordem da coleção. Não foi possível carregar a ordem de mais vendidos.';
          status.hidden = false;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
      this.waitForSwiper();
    }

    waitForSwiper(attempt = 0) {
      if (!this.isConnected) return;
      if (!window.Swiper) {
        if (attempt < 100) this.timer = setTimeout(() => this.waitForSwiper(attempt + 1), 50);
        return;
      }
      const count = this.querySelectorAll('.swiper-slide').length;
      if (!count) return;
      const options = this.options;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slider = new window.Swiper(this.querySelector('.swiper'), {
        slidesPerView: Math.min(options.mobile, count),
        slidesPerGroup: Math.max(1, Math.floor(Math.min(options.mobile, count))),
        spaceBetween: options.gap,
        breakpoints: {
          750: { slidesPerView: Math.min(options.tablet, count), slidesPerGroup: Math.max(1, Math.floor(Math.min(options.tablet, count))) },
          1100: { slidesPerView: Math.min(options.desktop, count), slidesPerGroup: Math.max(1, Math.floor(Math.min(options.desktop, count))) },
        },
        loop: options.loop && count >= Math.ceil(Math.max(options.mobile, options.tablet, options.desktop)) + Math.floor(Math.max(options.mobile, options.tablet, options.desktop)),
        speed: reduced ? 0 : options.speed,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { prevSlideMessage: 'Cursos anteriores', nextSlideMessage: 'Próximos cursos', paginationBulletMessage: 'Ir para o grupo {{index}}' },
        pagination: { el: this.querySelector('.cl-product-carousel__pagination'), clickable: true, bulletElement: 'button' },
        navigation: { prevEl: this.querySelector('.cl-product-carousel__prev'), nextEl: this.querySelector('.cl-product-carousel__next') },
        autoplay: options.autoplay && !reduced && count > 1 ? { delay: options.delay, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
      });
    }

    disconnectedCallback() {
      this.started = false;
      this.controller?.abort();
      clearTimeout(this.timer);
      this.slider?.destroy(true, true);
      this.slider = null;
    }
  });
}
